import { LOGIN_ROUTE } from "@/routing/app-routes";
import composeRoute from "../routes/utils/route-utils/route-utils";
import { DISALLOWED_REDIRECTS, SESSION_EXPIRED } from "./auth";
import { removeToken } from "./token-utils";
import { REDIRECT_KEY } from "@/constants/local-storage-keys";
import { INVITE_TOKEN } from "badlands-shared";

export const containsDisallowedRedirect = (url) => {
  return !DISALLOWED_REDIRECTS.every((dis) => !url.includes(dis));
};

export const storeInviteTokenFromURL = () => {
  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get(INVITE_TOKEN);
  if (inviteToken) {
    window.localStorage.setItem(INVITE_TOKEN, JSON.stringify(inviteToken));
  }
};

export const storePushURL = () => {
  if (
    DISALLOWED_REDIRECTS.every((url) => !window.location.pathname.includes(url))
  ) {
    const redirectUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (redirectUrl) {
      window.localStorage.setItem(REDIRECT_KEY, redirectUrl);
    }
  }
};

export const removePushURL = () => {
  window.localStorage.removeItem(REDIRECT_KEY);
};

export const getPushURL = () => {
  let redirectURL = window.localStorage.getItem(REDIRECT_KEY);
  if (redirectURL && containsDisallowedRedirect(redirectURL)) {
    redirectURL = undefined;
  }
  removePushURL();
  return redirectURL;
};

export const checkSession = (expiration, shouldRedirect = true) => {
  if (
    shouldRedirect &&
    typeof expiration === "number" &&
    expiration * 1000 < new Date().getTime()
  ) {
    removeToken();
    storePushURL();
    window.location.href = composeRoute(
      LOGIN_ROUTE,
      [],
      [{ key: SESSION_EXPIRED, value: "1" }],
    );
    return false;
  }
  return true;
};
